import PaypalBlue from './Paypal-Blue.svg';
import PaypalWhite from './Paypal-White.svg';

type PayPalColor = 'gold' | 'silver' | 'black' | 'white' | 'blue';

interface PaypalLogoProps {
  color: PayPalColor;
  className?: string;
  width?: number;
  height?: number;
}

const PaypalLogo = ({ color }: PaypalLogoProps) => {
  const paypalLogos: Record<PayPalColor, string> = {
    gold: PaypalBlue,
    silver: PaypalBlue,
    black: PaypalWhite,
    white: PaypalBlue,
    blue: PaypalWhite,
  };
  return (
    <img
      src={paypalLogos[color]}
      alt={`PayPal ${color} logo`}
      className="h-5 w-auto"
    />
  );
};

export default PaypalLogo;
